import { diContainer } from "@/core/di";
import AbstractDownloadHandler from "./AbstractDownloadHandler";
import { MimeTypes, IDownload } from "../types";
import { DITypes } from "@/core/@types/types";
import "reflect-metadata";
import { injectable } from "inversify";

@injectable()
export default class PFXDownloadHandler extends AbstractDownloadHandler {
  handle(mimeType: MimeTypes): IDownload | null {
    if (mimeType === MimeTypes.PFX)
      return diContainer.get<IDownload>(DITypes.DOWNLOAD_PFX);

    return super.handle(mimeType);
  }
}
